/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CostExcludingTaxesResource } from './';
import {
    CostExcludingTaxesResourceFromJSON,
    CostExcludingTaxesResourceFromJSONTyped,
    CostExcludingTaxesResourceToJSON,
} from './';
import type { FreelancerClientTeamResource } from './';
import {
    FreelancerClientTeamResourceFromJSON,
    FreelancerClientTeamResourceFromJSONTyped,
    FreelancerClientTeamResourceToJSON,
} from './';
import type { FreelancerCompanyComplianceStatus } from './';
import {
    FreelancerCompanyComplianceStatusFromJSON,
    FreelancerCompanyComplianceStatusFromJSONTyped,
    FreelancerCompanyComplianceStatusToJSON,
} from './';
import type { MisclassificationThresholdAlertResource } from './';
import {
    MisclassificationThresholdAlertResourceFromJSON,
    MisclassificationThresholdAlertResourceFromJSONTyped,
    MisclassificationThresholdAlertResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerWorkforceDetailsV2Resource
 */
export interface FreelancerWorkforceDetailsV2Resource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    photoUrl?: string;
    /**
     * 
     * @type {CostExcludingTaxesResource}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    costExcludingTaxes: CostExcludingTaxesResource;
    /**
     * 
     * @type {number}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    totalWorkedDays: number;
    /**
     * 
     * @type {string}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    freelancerCompanyId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    freelancerProfileId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    freelancerAccountId: string;
    /**
     * 
     * @type {FreelancerCompanyComplianceStatus}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    complianceStatus: FreelancerCompanyComplianceStatus;
    /**
     * 
     * @type {string}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    headline?: string;
    /**
     * List of client teams the freelancer has worked / currently works with
     * @type {Array<FreelancerClientTeamResource>}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    clientTeams: Array<FreelancerClientTeamResource>;
    /**
     * List of misclassification thresholds alerts
     * @type {Array<MisclassificationThresholdAlertResource>}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    misclassificationThresholdAlerts: Array<MisclassificationThresholdAlertResource>;
    /**
     * Distinct ISO 3166-1 alpha-2 country codes from the client legal entities the freelancer worked with
     * @type {Array<string>}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    countries: Array<string>;
    /**
     * True if the freelancer has at least one ongoing project with this organisation
     * @type {boolean}
     * @memberof FreelancerWorkforceDetailsV2Resource
     */
    hasActiveProject: boolean;
}

/**
 * Check if a given object implements the FreelancerWorkforceDetailsV2Resource interface.
 */
export function instanceOfFreelancerWorkforceDetailsV2Resource(value: object): value is FreelancerWorkforceDetailsV2Resource {
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('costExcludingTaxes' in value) || value['costExcludingTaxes'] === undefined) return false;
    if (!('totalWorkedDays' in value) || value['totalWorkedDays'] === undefined) return false;
    if (!('freelancerCompanyId' in value) || value['freelancerCompanyId'] === undefined) return false;
    if (!('freelancerAccountId' in value) || value['freelancerAccountId'] === undefined) return false;
    if (!('complianceStatus' in value) || value['complianceStatus'] === undefined) return false;
    if (!('clientTeams' in value) || value['clientTeams'] === undefined) return false;
    if (!('misclassificationThresholdAlerts' in value) || value['misclassificationThresholdAlerts'] === undefined) return false;
    if (!('countries' in value) || value['countries'] === undefined) return false;
    if (!('hasActiveProject' in value) || value['hasActiveProject'] === undefined) return false;
    return true;
}

export function FreelancerWorkforceDetailsV2ResourceFromJSON(json: any): FreelancerWorkforceDetailsV2Resource {
    return FreelancerWorkforceDetailsV2ResourceFromJSONTyped(json, false);
}

export function FreelancerWorkforceDetailsV2ResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerWorkforceDetailsV2Resource {
    if (json == null) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'costExcludingTaxes': CostExcludingTaxesResourceFromJSON(json['costExcludingTaxes']),
        'totalWorkedDays': json['totalWorkedDays'],
        'freelancerCompanyId': json['freelancerCompanyId'],
        'freelancerProfileId': json['freelancerProfileId'] == null ? undefined : json['freelancerProfileId'],
        'freelancerAccountId': json['freelancerAccountId'],
        'complianceStatus': FreelancerCompanyComplianceStatusFromJSON(json['complianceStatus']),
        'headline': json['headline'] == null ? undefined : json['headline'],
        'clientTeams': ((json['clientTeams'] as Array<any>).map(FreelancerClientTeamResourceFromJSON)),
        'misclassificationThresholdAlerts': ((json['misclassificationThresholdAlerts'] as Array<any>).map(MisclassificationThresholdAlertResourceFromJSON)),
        'countries': json['countries'],
        'hasActiveProject': json['hasActiveProject'],
    };
}

export function FreelancerWorkforceDetailsV2ResourceToJSON(value?: FreelancerWorkforceDetailsV2Resource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullName': value['fullName'],
        'photoUrl': value['photoUrl'],
        'costExcludingTaxes': CostExcludingTaxesResourceToJSON(value['costExcludingTaxes']),
        'totalWorkedDays': value['totalWorkedDays'],
        'freelancerCompanyId': value['freelancerCompanyId'],
        'freelancerProfileId': value['freelancerProfileId'],
        'freelancerAccountId': value['freelancerAccountId'],
        'complianceStatus': FreelancerCompanyComplianceStatusToJSON(value['complianceStatus']),
        'headline': value['headline'],
        'clientTeams': ((value['clientTeams'] as Array<any>).map((v) => FreelancerClientTeamResourceToJSON(v))),
        'misclassificationThresholdAlerts': ((value['misclassificationThresholdAlerts'] as Array<any>).map((v) => MisclassificationThresholdAlertResourceToJSON(v))),
        'countries': value['countries'],
        'hasActiveProject': value['hasActiveProject'],
    };
}

